import React from 'react';
import PropTypes from 'prop-types';
import {withRouter, locationShape, routerShape} from 'react-router';
import {action, observable} from 'mobx';
import {observer, inject} from 'mobx-react';

import {suspectInfiniteLoop} from 'spa/debug';
import NotFound from './NotFound';
import Go from 'spa/Components/Go';
import LoadingIndicator from 'spa/Components/LoadingIndicator';
import {withI18n} from 'spa/Components/Context';

// const COUNTRIES_SEARCH = {visible: 1};

@withRouter
// @inject(({store: {countries}}) => ({countries}))
@observer
@withI18n
class Locale extends React.Component {
  static propTypes = {
    location: locationShape.isRequired,
    router: routerShape.isRequired,
    routes: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
    // countries: PropTypes.object.isRequired,
    children: PropTypes.node,
  };

  static childContextTypes = {
    createLocaleLink: PropTypes.func.isRequired,
  };

  getChildContext() {
    return {
      createLocaleLink: (
        locale,
        link = this.props.location.pathname + this.props.location.search,
      ) =>
        link.replace(`/${this.context.i18n.lc}`, `/${locale.toLowerCase()}`),
    };
  }

  @action UNSAFE_componentWillMount() {
    // FIXME - apis are missing
    // this.props.countries.maybeLoadSearch(COUNTRIES_SEARCH);
    this.setLocale(this.props.params.locale);
  }

  @action UNSAFE_componentWillReceiveProps(nextProps) {
    this.setLocale(nextProps.params.locale);
  }

  @action
  @suspectInfiniteLoop
  setLocale(locale) {
    if (!locale) {
      throw new Error('Missing locale in url');
    }

    const {i18n} = this.context;
    if (i18n.lc === locale) {
      this.isValidLocale = true;
      return;
    }

    const newLocale = i18n.negotiateLocale(locale);
    if (!newLocale) {
      // not supported
      this.isValidLocale = false;
      return;
    }

    this.isValidLocale = true;
    i18n.setLocale(newLocale);
  }

  @observable isValidLocale = false;

  render() {
    const {i18n} = this.context;
    const locale = i18n.lc;

    if (!locale && i18n.SUPPORTED_LOCALES.map(loc => loc.toLowerCase()).indexOf(this.props.params.locale) === -1) {
      return (<NotFound {...this.props} />);
    }
    if (!locale) {
      // wait
      return <LoadingIndicator style={{color: '#333', fontSize: 15}} />;
    }
    if (locale && locale !== this.props.params.locale) {
      const location = this.props.router.createLocation({
        state: this.props.location.state,
        hash: this.props.location.hash,
        search: this.props.location.search,
        pathname: this.props.location.pathname.replace(this.props.params.locale, locale),
      });
      return (
        <Go
          to={location}
          statusCode={301}
          replace
        />
      );
    }

    if (!this.isValidLocale) {
      return <NotFound {...this.props} />;
    }

    let Layout;
    for (let i = this.props.routes.length - 1; i >= 0; --i) {
      const route = this.props.routes[i];
      if (route && route.layout) {
        Layout = route.layout;
        break;
      }
    }

    return (
      <Layout {...this.props}>
        {this.props.children}
      </Layout>
    );
  }
}

export default Locale;



// WEBPACK FOOTER //
// ./spa/Pages/Locale.jsx